import { render, staticRenderFns } from "./NotaDePesagem.vue?vue&type=template&id=22d4b13a&scoped=true&lang=pug"
import script from "./NotaDePesagem.vue?vue&type=script&lang=js"
export * from "./NotaDePesagem.vue?vue&type=script&lang=js"
import style0 from "./NotaDePesagem.vue?vue&type=style&index=0&id=22d4b13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d4b13a",
  null
  
)

export default component.exports